import { lazyLoad } from 'utils/loadable';

export const PointUsedLogPage = lazyLoad(
  () => import('./index'),
  module => module.PointUsedLogPage,
);
